/** @jsx jsx */
import { useState, useCallback, useMemo } from "react";
import { Column } from "react-table";
import { css, jsx } from "@emotion/core";
import DataTable from "components/organismos/DataTable/DataTable";
import { deleteById } from "api/vacationMaster";
import useToastNotification from "hooks/useToastNotification";
import { useVacationMaster } from "./hooks";
import SidebarTemplate from "components/templates/SidebarTemplate";
import FormContents from "components/atoms/Form/FormContents";
import IconLabelButton from "components/molecules/IconLabelButton";
import { useHistory } from "react-router-dom";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { SubActionButton } from "components/atoms/Button";
import ConfirmModal from "components/organismos/ConfirmModal";
import VacationDomain from "domain/vacation";
import BlockUI from "components/molecules/BlockUi";
import FormTitle from "components/atoms/Form/FormTitle";

const styles = {
  columnOne: css({}),
  filterSearch: css({
    marginLeft: "37px",
    marginBottom: "10px",
  }),
};
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const VacationMasterPage = () => {
  const history = useHistory();
  const {
    vacationList,
    setVacationList,
    blocking,
    setBlocking,
    detailRole,
  } = useVacationMaster();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedVacationMaster, setSelectedVacationMaster] = useState(
    VacationDomain.generateInitial()
  );
  const { successNotification, errorNotification } = useToastNotification();

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const openConfirmModal = useCallback((vacation: VacationDomain) => {
    setConfirmModalOpen(true);
    setSelectedVacationMaster(vacation);
  }, []);

  const deleteVacationMaster = useCallback(() => {
    setConfirmModalOpen(false);
    setBlocking(true);
    const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";
    deleteById(companyCode, selectedVacationMaster.holidayId)
      .then((response: any) => {
        setVacationList(
          vacationList.filter(
            (vacation) =>
              vacation.holidayId !== selectedVacationMaster.holidayId
          )
        );
        setBlocking(false);
        successNotification("削除しました。");
      })
      .catch((error) => {
        setBlocking(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          let msgError = "";
          error.response.data.errors.map((item: { defaultMessage: string }) => {
            msgError += `${item.defaultMessage}\n`;
            return msgError;
          });
          errorNotification(msgError);
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }
      });
  }, [
    errorNotification,
    selectedVacationMaster.holidayId,
    setVacationList,
    successNotification,
    vacationList,
    setBlocking,
  ]);
  const columns: Array<Column<VacationDomain>> = useMemo(
    () => [
      {
        Header: () => null,
        id: "actionButton",
        disableSortBy: true,
        Cell: (cell: {
          row: { isExpanded: boolean; original: VacationDomain };
        }) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <FlexBox customStyle={styles.columnOne}>
                <FlexBoxItem marginLeft="5px">
                  <SubActionButton
                    action={0}
                    text={detailRole.editable === 1 ? `編集` : `参照`}
                    onClick={() => {
                      history.push(
                        `/vacationMaster/edit/${cell.row.original.holidayId}`
                      );
                    }}
                  />
                </FlexBoxItem>
                {detailRole.editable === 1 ? (
                  <FlexBoxItem marginLeft="5px">
                    <SubActionButton
                      action={1}
                      text="削除"
                      onClick={() => {
                        openConfirmModal(cell.row.original);
                      }}
                    />
                  </FlexBoxItem>
                ) : null}
              </FlexBox>
            </div>
          );
        },
      },
      {
        Header: "休暇コード",
        accessor: "holidayCode",
      },
      {
        Header: "休暇名",
        accessor: "holidayName",
      },
    ],
    [openConfirmModal, history, detailRole]
  );

  return (
    <SidebarTemplate>
      <BlockUI blocking={blocking}>
        <FormContents>
          <FormTitle bold={true} title="休暇マスタ" />
          <div
            style={{ marginLeft: "27px", width: "80px", paddingBottom: "30px" }}
          >
            {detailRole.editable === 1 && (
              <IconLabelButton
                onClick={() => history.push("/vacationMaster/create")}
                iconType="addCircle"
                text="追加"
              />
            )}
          </div>
          <div
            css={css`
              table {
                table-layout: auto;
              }
              table th:nth-of-type(1) {
                width: 100px;
              }
              table th:nth-of-type(2) {
                width: 100px;
                text-align: left;
              }
              table th:nth-of-type(3) {
                width: calc(100% - 200px);
                text-align: left;
              }
            `}
          >
            <DataTable
              columns={columns}
              data={vacationList}
              isGlobalFilter={true}
              globalSearchStyle={styles.filterSearch}
              containerStyle={css({
                overflowX: "auto",
              })}
            />
          </div>
          <ConfirmModal
            open={confirmModalOpen}
            closeHandler={closeConfirmModal}
            title="休暇マスタを削除"
            content="休暇マスタを削除します。よろしいですか？"
            submitText="削除する"
            onSubmit={deleteVacationMaster}
            typeSubmit={"reject"}
          />
        </FormContents>
      </BlockUI>
    </SidebarTemplate>
  );
};

export default VacationMasterPage;
